import * as React from 'react';
import { VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { Icon } from '../Icon/Icon.js';
import { useId } from '../../utils/hooks/useId.js';
import './HeaderItem.scss.js';

const bem = Bem.create("vai-header-item");
const HeaderItem = (props) => {
  const { htmlId, dataTa, className, onClick, startIcon, title, isOpen, component = "div", innerRef, ...rest } = props;
  const id = useId(htmlId, ["header item"]);
  const hasChevron = isOpen !== void 0;
  const hasAction = onClick !== void 0;
  const classes = addClass(bem.block(hasAction && "with-action", isOpen && "active"), className);
  const Component = component;
  const renderStartIcon = (bemObject) => {
    if (startIcon) {
      return /* @__PURE__ */ React.createElement("span", {
        className: bemObject.element("icon-start")()
      }, startIcon);
    }
    return null;
  };
  return /* @__PURE__ */ React.createElement(Component, {
    id: id.toString(),
    "data-ta": dataTa,
    className: classes,
    onClick,
    ref: innerRef,
    ...rest
  }, renderStartIcon(bem), title && /* @__PURE__ */ React.createElement("span", {
    id: id.copyWith(["title"]).toString(),
    className: bem.element("title")()
  }, title), hasChevron && /* @__PURE__ */ React.createElement(Icon, {
    className: bem.element("icon-chevron")(),
    name: isOpen ? VaiIcon.ChevronUp : VaiIcon.ChevronDown
  }));
};

export { HeaderItem };
